import { apiCamelize } from '@cbhq/instant-api-hooks-core/util';

export function mockGetApplications() {
  const apiResponseMock = {
    spotlight: {
      application: {
        application_id: 'APPLICATION_IDENTIFIER_CB_TRACER',
        label: 'Tracer',
        destination_uri: 'https://app.analytics.coinbase.com',
        tile_name: 'analyticsNavigation-2',
        category: 'APPLICATION_CATEGORY_INSTITUTIONAL',
        position: '4',
        tile_urls: {
          dark: 'https://static-assets.coinbase.com/ui-infra/illustration/v1/pictogram/svg/dark/analyticsNavigation-2.svg',
          light:
            'https://static-assets.coinbase.com/ui-infra/illustration/v1/pictogram/svg/light/analyticsNavigation-2.svg',
        },
      },
      description:
        'Coinbase One is a subscription service that gives you access to Coinbase’s top-tier products and services.',
    },

    applications: [
      {
        application_id: 'APPLICATION_IDENTIFIER_DOCS',
        label: 'Dev Docs with really long label that will overflow the tile button',
        destination_uri: 'https://docs.cloud.coinbase.com',
        tile_name: 'notificationHubNews',
        category: 'APPLICATION_CATEGORY_DEVELOPER',
        position: '3',
        tile_urls: {
          dark: 'https://static-assets.coinbase.com/ui-infra/illustration/v1/pictogram/svg/dark/notificationHubNews-2.svg',
          light:
            'https://static-assets.coinbase.com/ui-infra/illustration/v1/pictogram/svg/light/notificationHubNews-2.svg',
        },
      },
      {
        application_id: 'APPLICATION_IDENTIFIER_BASE',
        label: 'Base Build',
        destination_uri: 'https://cloud-web-staging.cbhq.net/products/base',
        tile_name: 'baseLogoNavigation',
        category: 'APPLICATION_CATEGORY_DEVELOPER',
        position: '2',
        tag: {
          label: 'New',
          color_scheme: 'blue',
          intent: 'promotional',
        },
        tile_urls: {
          dark: 'https://static-assets.coinbase.com/ui-infra/illustration/v1/pictogram/svg/dark/baseLogoNavigation-2.svg',
          light:
            'https://static-assets.coinbase.com/ui-infra/illustration/v1/pictogram/svg/light/baseLogoNavigation-2.svg',
        },
      },
      {
        application_id: 'APPLICATION_IDENTIFIER_BASE_APP',
        label: 'Base App',
        destination_uri: 'https://join.base.app/',
        tile_name: 'baseLogoNavigation-6',
        category: 'APPLICATION_CATEGORY_INDIVIDUAL',
        position: '3',
        tile_urls: {
          dark: 'https://static-assets.coinbase.com/ui-infra/illustration/v1/pictogram/svg/dark/baseLogoNavigation-6.svg',
          light:
            'https://static-assets.coinbase.com/ui-infra/illustration/v1/pictogram/svg/light/baseLogoNavigation-6.svg',
        },
      },
      {
        application_id: 'APPLICATION_IDENTIFIER_RETAIL',
        label: 'Coinbase',
        destination_uri: 'https://coinbase-staging.cbhq.net/home',
        tile_name: 'coinbaseLogoNavigation',
        category: 'APPLICATION_CATEGORY_INDIVIDUAL',
        position: '1',
        tile_urls: {
          dark: 'https://static-assets.coinbase.com/ui-infra/illustration/v1/pictogram/svg/dark/coinbaseLogoNavigation-2.svg',
          light:
            'https://static-assets.coinbase.com/ui-infra/illustration/v1/pictogram/svg/light/coinbaseLogoNavigation-2.svg',
        },
        id: '2ZPgNhLdLmW6rbxN5CiAYU98pOd',
      },
      {
        application_id: 'APPLICATION_IDENTIFIER_HELP_CENTER',
        label: 'Help',
        destination_uri: 'https://helpcenter-staging.cbhq.net',
        tile_name: 'helpCenterNavigation',
        category: 'APPLICATION_CATEGORY_MORE',
        position: '1',
        tile_urls: {
          dark: 'https://static-assets.coinbase.com/ui-infra/illustration/v1/pictogram/svg/dark/helpCenterNavigation-2.svg',
          light:
            'https://static-assets.coinbase.com/ui-infra/illustration/v1/pictogram/svg/light/helpCenterNavigation-2.svg',
        },
        id: '2LObuc1k8LHvIh2oNP5awvJ6FPm',
      },
      {
        application_id: 'APPLICATION_IDENTIFIER_ACCOUNTS',
        label: 'Account',
        destination_uri: 'https://accounts-staging.cbhq.net/profile',
        tile_name: 'accountsNavigation',
        category: 'APPLICATION_CATEGORY_MORE',
        position: '2',
        tile_urls: {
          dark: 'https://static-assets.coinbase.com/ui-infra/illustration/v1/pictogram/svg/dark/accountsNavigation-2.svg',
          light:
            'https://static-assets.coinbase.com/ui-infra/illustration/v1/pictogram/svg/light/accountsNavigation-2.svg',
        },
        id: '2HsV58rJs04aIQObDvkWJtYcIo4',
      },
      {
        application_id: 'APPLICATION_IDENTIFIER_EXCHANGE',
        label: 'Exchange',
        destination_uri: 'https://coinbase-staging.cbhq.net/exchange',
        tile_name: 'exchangeNavigation',
        category: 'APPLICATION_CATEGORY_INSTITUTIONAL',
        position: '2',
        tile_urls: {
          dark: 'https://static-assets.coinbase.com/ui-infra/illustration/v1/pictogram/svg/dark/exchangeNavigation-2.svg',
          light:
            'https://static-assets.coinbase.com/ui-infra/illustration/v1/pictogram/svg/light/exchangeNavigation-2.svg',
        },
      },
      {
        application_id: 'APPLICATION_IDENTIFIER_DERIVATIVES',
        label: 'Derivatives',
        destination_uri: 'https://coinbase-staging.cbhq.net/derivatives',
        tile_name: 'derivativesNavigation',
        category: 'APPLICATION_CATEGORY_INSTITUTIONAL',
        position: '3',
        tag: {
          label: 'New',
          color_scheme: 'blue',
          intent: 'promotional',
        },
        tile_urls: {
          dark: 'https://static-assets.coinbase.com/ui-infra/illustration/v1/pictogram/svg/dark/derivativesNavigation-2.svg',
          light:
            'https://static-assets.coinbase.com/ui-infra/illustration/v1/pictogram/svg/light/derivativesNavigation-2.svg',
        },
      },
      {
        application_id: 'APPLICATION_IDENTIFIER_PRIME',
        label: 'Prime',
        destination_uri: 'https://prime-staging.cbhq.net/portfolio',
        tile_name: 'primeNavigation',
        category: 'APPLICATION_CATEGORY_INSTITUTIONAL',
        position: '1',
        tile_urls: {
          dark: 'https://static-assets.coinbase.com/ui-infra/illustration/v1/pictogram/svg/dark/primeNavigation-2.svg',
          light:
            'https://static-assets.coinbase.com/ui-infra/illustration/v1/pictogram/svg/light/primeNavigation-2.svg',
        },
        id: '2ULhRSFMybVYdhYMMPVI91riKEi',
      },
      {
        application_id: 'APPLICATION_IDENTIFIER_BUSINESS',
        label: 'Business',
        destination_uri: 'https://business.coinbase.com',
        tile_name: 'commerceNavigation',
        category: 'APPLICATION_CATEGORY_BUSINESS',
        position: '1',
        tile_urls: {
          dark: 'https://static-assets.coinbase.com/ui-infra/illustration/v1/pictogram/svg/dark/commerceNavigation-2.svg',
          light:
            'https://static-assets.coinbase.com/ui-infra/illustration/v1/pictogram/svg/light/commerceNavigation-2.svg',
        },
        id: 'test-business-main-id',
      },
    ],
    categories: [
      {
        identifier: 'APPLICATION_CATEGORY_DEVELOPER',
        label: 'Platform',
        position: '3',
      },
      {
        identifier: 'APPLICATION_CATEGORY_INDIVIDUAL',
        label: 'For Individuals',
        position: '1',
      },
      {
        identifier: 'APPLICATION_CATEGORY_INSTITUTIONAL',
        label: 'For Institutions',
        position: '2',
      },
      {
        identifier: 'APPLICATION_CATEGORY_BUSINESS',
        label: 'For Business',
        position: '4',
      },
      {
        identifier: 'APPLICATION_CATEGORY_MORE',
        label: 'More',
        position: '5',
      },
    ],
  };

  return apiCamelize(apiResponseMock);
}
